module.exports = __webpack_public_path__ + "static/img/pems.a7fab32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pems.jpg
// module id = itm2
// module chunks = 0